// extracted by mini-css-extract-plugin
export const aboutContainer = "StaticPage-module--aboutContainer--zPjv2";
export const aboutHeader = "StaticPage-module--aboutHeader--A4su3";
export const contentWrapper = "StaticPage-module--contentWrapper--2tN-C";
export const aboutDescription = "StaticPage-module--aboutDescription--3Czsj";